import { ElementType, Suspense, lazy, useEffect, useState } from 'react'
import { Navigate, RouteObject, useRoutes } from 'react-router-dom'
import AmeSpin from './components/AmeSpin/AmeSpin'
import { PAGE_LINKS ,PCPAGE_LINKS,MOBILE_PAGE_LINKS} from './helpers/commonConsts'
import { Spin } from 'antd'
import { adminService } from './services/adminService'
import { commonUtils } from '@/helpers/commonUtils'

const Loadable = (Component: ElementType) => (props: any) => {
  const isMobile = commonUtils.isMobile()
  const isPcRoute = Object.values(PCPAGE_LINKS).some((link) => window.location.pathname === link)
  const isMobileRoute = Object.values(MOBILE_PAGE_LINKS).some((link) => window.location.pathname === link)
  // 移动端访问PC页面，跳转到移动端
  if (isPcRoute && isMobile) {
    if(window.location.href.indexOf('admin') === -1){
      const { slug_code} = commonUtils.getUrlArgs()
      // if (utm) {
      //   localStorage.setItem('utm', utm)
      //   sessionStorage.setItem('utm', utm)
      // }
  
      // if (kword) {
      //   localStorage.setItem('kword', kword)
      //   sessionStorage.setItem('kword', kword)
      // }
  
      if (slug_code) {
        localStorage.setItem('slug_code', slug_code)
        sessionStorage.setItem('slug_code', slug_code)
      }
      window.location.href = window.location.origin + '/mobile'+ '?slug_code=' + slug_code
      return null
    }
  }

  // PC端访问移动端页面，跳转到PC端
  if (isMobileRoute && !isMobile) {
    window.location.href = window.location.origin + PCPAGE_LINKS.home
    return null
  }

  return (
    <Suspense fallback={<AmeSpin fullscreen={true} />}>
      <Component {...props} />
    </Suspense>
  )
}

const AdminAuth = (p: { children: React.ReactNode }) => {
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    adminService
      .getUserInfo()
      .then(() => {
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }, [])

  if (loading) {
    return (
      <div
        style={{
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin spinning={loading} />
      </div>
    )
  }

  return adminService.userData ? p.children : <Navigate to={PAGE_LINKS.adminLogin} />
}

const HomePage = Loadable(lazy(() => import('./pages/HomePage/HomePage')))
const AdminLoginPage = Loadable(lazy(() => import('./pages/admin/LoginPage/LoginPage')))
const AdminLayout = Loadable(lazy(() => import('./pages/admin/AdminPage/AdminLayout')))
const GiftVipPage = Loadable(lazy(() => import('./pages/admin/AdminPage/pages/GiftVipPage')))
const CancelVipPage = Loadable(lazy(() => import('./pages/admin/AdminPage/pages/CancelVipPage')))
const SaleSlugPage = Loadable(lazy(() => import('./pages/admin/AdminPage/pages/SaleSlugPage')))
const MobilePage= Loadable(lazy(() => import('./pages/mobile/home')))
const TemplateDetailPage = Loadable(lazy(() => import('./pages/mobile/TemplateDetail')))
const SearchPage = Loadable(lazy(() => import('@/pages/mobile/SearchPage/SearchPage')))
const BuyRecommendPage = Loadable(lazy(() => import('@/pages/mobile/BuyRecommendPage/BuyRecommendPage')))

const routes: RouteObject[] = [
  {
    path: PAGE_LINKS.home,
    element: <HomePage />,
  },
  {
    path: PAGE_LINKS.adminLogin,
    element: <AdminLoginPage />,
  },
  {
    path: '/mobile',
    element: <MobilePage />,
  },
  {
    path: `/mobile/search/:searchText`,
    element: <SearchPage />,
  },
  {
    path: '/mobile/template/:id',
    element: <TemplateDetailPage />,
  },
  {
    path: '/mobile/buyRecommend',
    element: <BuyRecommendPage />,
  },
  {
    path: PAGE_LINKS.admin,
    element: (
      <AdminAuth>
        <AdminLayout />
      </AdminAuth>
    ),
    children: [
      {
        index: true,
        element: <GiftVipPage />,
      },
      {
        path: PAGE_LINKS.cancelVip,
        element: <CancelVipPage />,
      },
      {
        path: PAGE_LINKS.saleSlug,
        element: <SaleSlugPage />,
      },
      {
        path: '*',
        element: <Navigate to={PAGE_LINKS.admin} replace />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to={PAGE_LINKS.home} replace />,
  },
]

export const Router = () => {
  return useRoutes(routes)
}
